const addToCart = document.querySelector('#AddToCart');

addToCart.addEventListener('click', (e) => {
    e.preventDefault();
    const addToCartForm = document.querySelector('form[action$="/cart/add"]');
    const formData = new FormData(addToCartForm);

     fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then((data) => {
      return fetch(window.Shopify.routes.root + 'cart.js');
    })
    .then(response => response.json())
    .then((data) => {
      modalOpen();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
});

let modalOpen = () => {
    $('#modalArea').fadeIn();
};

$('#closeModal1 , #modalBg , #closeModal2').click(function(e){
  e.preventDefault();
    $('#modalArea').fadeOut();
});